import { useEffect, useRef, useState } from "react";
import useWindowSize from "../../hooks/useWindowSize";

import Modal from "bootstrap/js/dist/modal";
import { useTheme } from "next-themes";
import { CrossIcon } from "../icons";
import { useTranslation } from "react-i18next";
import FundDetails from "../../pages/fundDetails";

export default function FundDetailsModal({ show, onClose, backdrop, keyboard, loading, funds, symbol, unitholder, setMenu }) {
  const modalRef = useRef(null);
  const bsModalRef = useRef(null);
  const [isModalOpen, setIsModalOpen] = useState(false);

  const screenSize = useWindowSize();
  const { t } = useTranslation();
  const { theme } = useTheme();

  useEffect(() => {
    if (!modalRef.current) return;
    bsModalRef.current = new Modal(modalRef.current, {
      backdrop: backdrop === "static" ? "static" : !!backdrop,
      keyboard: !!keyboard,
      focus: true,
    });

    // call onClose when user closes modal via backdrop/esc/button
    const onHidden = () => {
      setIsModalOpen(false);
      onClose?.();
    };
    const onShown = () => {
      setIsModalOpen(true);
      // let children know modal finished showing (useful if chart mounts after show)
      modalRef.current.dispatchEvent(new CustomEvent("modal:shown", { bubbles: true }));
    };

    modalRef.current.addEventListener("hidden.bs.modal", onHidden);
    modalRef.current.addEventListener("shown.bs.modal", onShown);

    return () => {
      modalRef.current?.removeEventListener("hidden.bs.modal", onHidden);
      modalRef.current?.removeEventListener("shown.bs.modal", onShown);
      bsModalRef.current?.dispose();
    };
  }, []);

  useEffect(() => {
    if (!bsModalRef.current) return;
    if (show) bsModalRef.current.show();
    else bsModalRef.current.hide();
  }, [show]);

  return (
    <div className='modal fade p-0' id='helpModal' tabIndex='-1' aria-labelledby='helpModal' aria-hidden='true' ref={modalRef}>
      <div
        className='modal-dialog modal-dialog-centered'
        style={{
          ["--bs-modal-width"]: "1200px",
          marginInline: screenSize >= 1210 ? "auto" : ".5rem",
        }}
      >
        <div
          className='modal-content position-relative'
          style={{
            backgroundColor: theme === "light" ? "rgb(230 230 230)" : "rgb(42 47 53)",
            color: theme === "light" ? "rgb(0,0,0)" : "rgb(232, 232, 232)",
          }}
        >
          <div
            className='position-absolute'
            style={{
              zIndex: "100",
              top: "0",
              insetInlineEnd: "0",
            }}
          >
            <button
              type='button'
              className='btn p-0 p-sm-1'
              aria-label='Close'
              style={{
                marginLeft: "0",
                marginRight: ".15rem",
                border: "none",
                boxShadow: "none",
              }}
              onClick={() => {
                if (modalRef.current) {
                  bsModalRef.current.toggle();
                }
              }}
            >
              <CrossIcon width={screenSize >= 576 ? 32 : 26} height={screenSize >= 576 ? 32 : 26} color={theme === "dark" ? "rgba(225,225,225,.7)" : "rgba(34, 34, 34, 0.8)"} />
            </button>
          </div>

          <div className='modal-body px-0 px-sm-3 pb-1'>
            {show ? (
              <FundDetails
                symbol={symbol}
                loading={loading}
                setMenu={setMenu}
                funds={funds}
                unitholder={unitholder}
                isModalOpen={isModalOpen}
                closeButton={() => {
                  if (modalRef.current) {
                    bsModalRef.current.toggle();
                  }
                }}
              />
            ) : (
              ""
            )}
          </div>
          {/* <div className='modal-footer border-0 flex-nowrap justify-content-center'>

              <button
                type='button'
                className='btn btn-primary border-0 p-0 px-3 d-flex align-items-center justify-content-center'
                onClick={() => {
                  if (modalRef.current) {
                    bsModalRef.current.toggle();
                  }
                }}
                style={{
                  minHeight: "38px",
                  minWidth: "80px",
                  fontSize: screenSize >= 576 ? "1rem" : ".9rem",
                }}
              >
                  {t("modals.common.close")}
              </button>
            </div> */}
        </div>
      </div>
    </div>
  );
}
